import { Box, Button, Divider, IconButton, Typography } from "@mui/material";
import {
  AddEcoEfficiencySection,
  EcoEfficiencyContext,
} from "../../../contexts/EcoEfficiencyContext";
import { useAuth } from "../../../contexts/UserContext";
import { common, input } from "../../../i18n";
import { useTranslation } from "react-i18next";
import { isEcoFPlanSettingOpen } from "../../../config/config";
import { OrganizationBreadcrumbs } from "../../emission/_components/OrganizationBreadcrumbs";

interface Props {
  children: JSX.Element;
}

export const AddEcoEfficiencyLayout = ({ children }: Props): JSX.Element => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const { organization } = useAuth();

  const { section, setSection, editData, exitModal } = EcoEfficiencyContext();

  const addEcoEfficiencySection: AddEcoEfficiencySection[] = [
    "Details",
    "Add-Actual-Data",
    "Plan-Setting",
  ];

  function buildMenu() {
    return addEcoEfficiencySection.map((a) => {
      let isDisabled: boolean = false;

      if (a === "Plan-Setting") {
        if (!isEcoFPlanSettingOpen) return undefined;
      } else {
        isDisabled = a === "Details" || editData ? false : true;
      }

      return (
        <Button
          key={a}
          variant={section === a ? "contained" : "text"}
          sx={{
            background: section === a ? "var(--status-bg)" : undefined,
            color: "var(--green)",
            "&.MuiButton-root:hover": {
              color: section === a ? "var(--white)" : undefined,
            },
            borderRadius: "32px",
            padding: "4px 16px",
          }}
          onClick={() => setSection(a)}
          disabled={isDisabled}
        >
          {t(a)}
        </Button>
      );
    });
  }

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      minHeight={0}
      height={"100%"}
      pt={"8px"}
    >
      <Typography variant="h1" color={"var(--dark)"}>
        <IconButton
          sx={{
            marginLeft: "-8px",
          }}
          onClick={exitModal}
        >
          <img src="/img/arrow-left.svg" alt="" />
        </IconButton>

        {editData ? t("Edit-Eco-Efficiency") : t("Add-Eco-Efficiency")}
      </Typography>
      <Box marginY={"20px"}>
        <OrganizationBreadcrumbs
          organization={organization?.name ?? ""}
          location={""}
          subOrganizations={editData?.suborganizationRef?.name ?? ""}
        />
      </Box>
      <Box display={"flex"} gap={"8px"} my={"20px"}>
        {buildMenu()}
      </Box>
      <Divider />
      <Box
        flexGrow={1}
        mt={"20px"}
        sx={{
          position: "relative",
          flexGrow: 1,
          overflowY: "auto",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
